import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-tea-green text-tea-cream overflow-hidden pt-10 pb-10 px-6 lg:px-8" data-id="element-160">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10 pointer-events-none" data-id="element-161">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-tea-gold blur-3xl" data-id="element-162"></div>
        <div className="absolute top-1/2 -left-24 w-64 h-64 rounded-full bg-tea-sage blur-3xl" data-id="element-163"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-164">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-6 items-center" data-id="element-165">
          <div className="max-w-2xl" data-id="element-166">
            <FadeIn delay={0.1} data-id="element-167">
              <span className="inline-block py-1 px-3 rounded-full bg-tea-gold/20 text-tea-gold border border-tea-gold/30 text-sm font-semibold tracking-wider uppercase mb-4" data-id="element-168">
                EL NEGOCIO DEL TÉ 2026
              </span>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-169">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold leading-tight mb-4 text-tea-cream" data-id="element-170">
                EL PLAN DE ESCAPE DEL TÉ:{' '}
                <span className="text-tea-gold italic font-light" data-id="element-171">
                  LANZA TU PROPIA MARCA DE BLENDS EN 21 DÍAS
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-172">
              <h2 className="text-lg md:text-xl text-tea-sage/90 font-body font-light leading-relaxed mb-6 max-w-xl" data-id="element-173">
                El Sistema Integral para mujeres agotadas del sistema que buscan
                independencia, propósito y un negocio de lujo artesanal desde
                casa.
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-174">
              <a href="#pricing" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold text-tea-green bg-tea-gold hover:bg-white transition-colors duration-300 rounded-sm shadow-lg hover:shadow-xl w-full sm:w-auto group" data-id="element-175">
                QUIERO COMENZAR MI NEGOCIO AHORA
                <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-176" />
              </a>
              <p className="mt-3 text-sm text-tea-sage/60 font-light text-center sm:text-left" data-id="element-177">
                Acceso inmediato. 100% Digital y descargable.
              </p>
            </FadeIn>
          </div>

          <FadeIn delay={0.5} direction="left" className="relative lg:ml-auto flex justify-center lg:justify-end" data-id="element-178">
            <div className="relative w-full max-w-md lg:max-w-lg" data-id="element-179">
              <img src="https://cdn.shopify.com/s/files/1/0981/8108/7598/files/PRODUCTO.png?v=1772406340" alt="El Negocio del Té - Guía para emprender con éxito" className="w-full h-auto drop-shadow-2xl" data-id="element-180" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}